module.exports = __webpack_public_path__ + "img/bb_g3_wrinkles-head.b7ae317b.svg";